var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { id: "moduleedit" } },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", [_vm._v(_vm._s(_vm.title))]),
          _c(
            "v-card-text",
            [
              _c(
                "v-overlay",
                { attrs: { value: _vm.loading } },
                [
                  _c("v-progress-circular", {
                    attrs: { indeterminate: "", size: "64", color: "primary" }
                  })
                ],
                1
              ),
              _c(
                "v-form",
                {
                  ref: "form",
                  model: {
                    value: _vm.valid,
                    callback: function($$v) {
                      _vm.valid = $$v
                    },
                    expression: "valid"
                  }
                },
                [
                  _c(
                    "v-tabs",
                    {
                      model: {
                        value: _vm.tab,
                        callback: function($$v) {
                          _vm.tab = $$v
                        },
                        expression: "tab"
                      }
                    },
                    [
                      _c("v-tab", [
                        _vm._v(_vm._s(_vm.$t("catalogedit.panel.basic")))
                      ]),
                      _vm._l(_vm.model.availableLocales, function(
                        locale,
                        index
                      ) {
                        return _c("v-tab", { key: index }, [
                          _vm._v(" " + _vm._s(locale) + " ")
                        ])
                      }),
                      _c(
                        "v-tab-item",
                        { key: "basic" },
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: _vm.$t(
                                        "catalogedit.label.module-id"
                                      ),
                                      hint:
                                        "Should match the ID built in the app",
                                      rules: [_vm.rules.required],
                                      required: ""
                                    },
                                    model: {
                                      value: _vm.model.uid,
                                      callback: function($$v) {
                                        _vm.$set(_vm.model, "uid", $$v)
                                      },
                                      expression: "model.uid"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-expansion-panels",
                            {
                              attrs: { focussed: "" },
                              model: {
                                value: _vm.panels,
                                callback: function($$v) {
                                  _vm.panels = $$v
                                },
                                expression: "panels"
                              }
                            },
                            [
                              _c(
                                "v-expansion-panel",
                                { key: "listing" },
                                [
                                  _c("v-expansion-panel-header", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("catalogedit.panel.listing")
                                        ) +
                                        " "
                                    )
                                  ]),
                                  _c(
                                    "v-expansion-panel-content",
                                    [
                                      _c(
                                        "v-row",
                                        [
                                          _c(
                                            "v-col",
                                            [
                                              _c("v-switch", {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "catalogedit.label.public"
                                                  ),
                                                  hint:
                                                    "Will become visible to all accounts that have access to entire library"
                                                },
                                                model: {
                                                  value: _vm.model.public,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.model,
                                                      "public",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "model.public"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-col",
                                            [
                                              _c(
                                                "v-menu",
                                                {
                                                  attrs: {
                                                    "close-on-content-click": false
                                                  },
                                                  scopedSlots: _vm._u([
                                                    {
                                                      key: "activator",
                                                      fn: function(ref) {
                                                        var on = ref.on
                                                        var attrs = ref.attrs
                                                        return [
                                                          _c(
                                                            "v-text-field",
                                                            _vm._g(
                                                              _vm._b(
                                                                {
                                                                  attrs: {
                                                                    label: _vm.$t(
                                                                      "catalogedit.label.release-date"
                                                                    ),
                                                                    readonly: ""
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm.model
                                                                        .releaseDate,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.model,
                                                                        "releaseDate",
                                                                        $$v
                                                                      )
                                                                    },
                                                                    expression:
                                                                      "model.releaseDate"
                                                                  }
                                                                },
                                                                "v-text-field",
                                                                attrs,
                                                                false
                                                              ),
                                                              on
                                                            )
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ]),
                                                  model: {
                                                    value: _vm.menu,
                                                    callback: function($$v) {
                                                      _vm.menu = $$v
                                                    },
                                                    expression: "menu"
                                                  }
                                                },
                                                [
                                                  _c("v-date-picker", {
                                                    on: {
                                                      change: function($event) {
                                                        _vm.menu = false
                                                      }
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.model.releaseDate,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.model,
                                                          "releaseDate",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "model.releaseDate"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-row",
                                        [
                                          _c(
                                            "v-col",
                                            [
                                              _c("v-text-field", {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "catalogedit.info-link"
                                                  ),
                                                  hint:
                                                    "Link to more information about the module"
                                                },
                                                model: {
                                                  value: _vm.model.infoLink,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.model,
                                                      "infoLink",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "model.infoLink"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-col",
                                            [
                                              _c("v-combobox", {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "catalogedit.label.supported-language"
                                                  ),
                                                  required: "",
                                                  rules: [
                                                    _vm.rules.localeRules
                                                  ],
                                                  multiple: "",
                                                  chips: "",
                                                  items: _vm.languages
                                                },
                                                model: {
                                                  value:
                                                    _vm.model.availableLocales,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.model,
                                                      "availableLocales",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "model.availableLocales"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-row",
                                        [
                                          _c(
                                            "v-col",
                                            [
                                              _c("v-text-field", {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "catalogedit.label.duration"
                                                  ),
                                                  type: "number"
                                                },
                                                model: {
                                                  value: _vm.model.duration,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.model,
                                                      "duration",
                                                      _vm._n($$v)
                                                    )
                                                  },
                                                  expression: "model.duration"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-col",
                                            [
                                              _c("v-select", {
                                                attrs: {
                                                  items: _vm.contentTypes,
                                                  label: _vm.$t(
                                                    "catalogedit.type"
                                                  ),
                                                  value: "module"
                                                },
                                                model: {
                                                  value: _vm.model.type,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.model,
                                                      "type",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "model.type"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-row",
                                        [
                                          _c(
                                            "v-col",
                                            [
                                              _c("v-checkbox", {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "catalogedit.label.learner-reports"
                                                  )
                                                },
                                                model: {
                                                  value:
                                                    _vm.model.learnerReports,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.model,
                                                      "learnerReports",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "model.learnerReports"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-col",
                                            [
                                              _c("v-select", {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "catalogedit.label.aiusage"
                                                  ),
                                                  items: _vm.aiUsage
                                                },
                                                model: {
                                                  value: _vm.model.aiUsage,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.model,
                                                      "aiUsage",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "model.aiUsage"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-row",
                                        [
                                          _c(
                                            "v-col",
                                            [
                                              _c("v-checkbox", {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "catalogedit.vrRecommended"
                                                  )
                                                },
                                                model: {
                                                  value:
                                                    _vm.model.vrRecommended,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.model,
                                                      "vrRecommended",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "model.vrRecommended"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-col",
                                            [
                                              _c("v-text-field", {
                                                attrs: {
                                                  label:
                                                    "Feature flag use wisely (else leave blank)"
                                                },
                                                model: {
                                                  value: _vm.model.flag,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.model,
                                                      "flag",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "model.flag"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-row",
                                        [
                                          _c("v-col", [
                                            _c("h3", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "catalogedit.label.tags"
                                                  )
                                                )
                                              )
                                            ])
                                          ])
                                        ],
                                        1
                                      ),
                                      _vm._l(_vm.model.tags, function(
                                        tag,
                                        index
                                      ) {
                                        return _c(
                                          "div",
                                          { key: index },
                                          [
                                            _c(
                                              "v-row",
                                              [
                                                _c("v-text-field", {
                                                  model: {
                                                    value:
                                                      _vm.model.tags[index],
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.model.tags,
                                                        index,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "model.tags[index]"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      }),
                                      _c(
                                        "v-row",
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: { icon: "", small: "" },
                                              on: { click: _vm.addTag }
                                            },
                                            [
                                              _c("v-icon", [_vm._v("mdi-plus")])
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-row",
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: _vm.$t(
                                                "catalogedit.label.new-tag"
                                              )
                                            },
                                            model: {
                                              value: _vm.newTag,
                                              callback: function($$v) {
                                                _vm.newTag = $$v
                                              },
                                              expression: "newTag"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    2
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-expansion-panel",
                                { key: "structure" },
                                [
                                  _c("v-expansion-panel-header", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("catalogedit.panel.structure")
                                        ) +
                                        " "
                                    )
                                  ]),
                                  _c(
                                    "v-expansion-panel-content",
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          items: ["linear", "free"],
                                          label: _vm.$t(
                                            "catalogedit.label.navigation-type"
                                          )
                                        },
                                        model: {
                                          value: _vm.model.navigationType,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.model,
                                              "navigationType",
                                              $$v
                                            )
                                          },
                                          expression: "model.navigationType"
                                        }
                                      }),
                                      _c(
                                        "div",
                                        [
                                          _c("p", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "catalogedit.label.topics"
                                                )
                                              ) +
                                                " (total " +
                                                _vm._s(_vm.sumCompletion) +
                                                ")"
                                            )
                                          ]),
                                          _vm._l(_vm.model.topics, function(
                                            topic,
                                            i
                                          ) {
                                            return _c(
                                              "div",
                                              { key: i, staticClass: "my-2" },
                                              [
                                                _c(
                                                  "v-row",
                                                  [
                                                    _c(
                                                      "v-col",
                                                      { attrs: { cols: "3" } },
                                                      [
                                                        _c("v-text-field", {
                                                          attrs: {
                                                            label: _vm.$t(
                                                              "catalogedit.label.id"
                                                            ),
                                                            outlined: "",
                                                            dense: ""
                                                          },
                                                          model: {
                                                            value: topic.id,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                topic,
                                                                "id",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "topic.id"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-col",
                                                      { attrs: { cols: "3" } },
                                                      [
                                                        _c("v-text-field", {
                                                          attrs: {
                                                            label: _vm.$t(
                                                              "catalogedit.label.duration"
                                                            ),
                                                            type: "number",
                                                            outlined: "",
                                                            dense: ""
                                                          },
                                                          model: {
                                                            value:
                                                              topic.duration,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                topic,
                                                                "duration",
                                                                _vm._n($$v)
                                                              )
                                                            },
                                                            expression:
                                                              "topic.duration"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-col",
                                                      { attrs: { cols: "3" } },
                                                      [
                                                        _c("v-text-field", {
                                                          attrs: {
                                                            label: _vm.$t(
                                                              "catalogedit.label.completion"
                                                            ),
                                                            type: "number",
                                                            outlined: "",
                                                            dense: ""
                                                          },
                                                          model: {
                                                            value:
                                                              topic.completion,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                topic,
                                                                "completion",
                                                                _vm._n($$v)
                                                              )
                                                            },
                                                            expression:
                                                              "topic.completion"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-col",
                                                      {
                                                        staticClass:
                                                          "text-right",
                                                        attrs: { cols: "3" }
                                                      },
                                                      [
                                                        _c(
                                                          "v-btn",
                                                          {
                                                            attrs: {
                                                              icon: "",
                                                              small: ""
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.deleteTopic(
                                                                  i
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("v-icon", [
                                                              _vm._v(
                                                                "mdi-minus"
                                                              )
                                                            ])
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          }),
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: { icon: "", small: "" },
                                              on: { click: _vm.addNewTopic }
                                            },
                                            [
                                              _c("v-icon", [_vm._v("mdi-plus")])
                                            ],
                                            1
                                          )
                                        ],
                                        2
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-expansion-panel",
                                { key: "platforms" },
                                [
                                  _c("v-expansion-panel-header", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("catalogedit.panel.platforms")
                                        ) +
                                        " "
                                    )
                                  ]),
                                  _c(
                                    "v-expansion-panel-content",
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: _vm.$t(
                                            "catalogedit.label.bundle-id"
                                          ),
                                          hint: "leave blank for OTS build"
                                        },
                                        model: {
                                          value: _vm.model.bundleID,
                                          callback: function($$v) {
                                            _vm.$set(_vm.model, "bundleID", $$v)
                                          },
                                          expression: "model.bundleID"
                                        }
                                      }),
                                      _c("v-combobox", {
                                        staticClass: "tag-input",
                                        attrs: {
                                          multiple: "",
                                          items: _vm.platforms,
                                          label: _vm.$t(
                                            "catalogedit.label.supported-platforms"
                                          ),
                                          "append-icon": "",
                                          chips: "",
                                          "deletable-chips": "",
                                          hint:
                                            "Leave blank for all platform support"
                                        },
                                        model: {
                                          value: _vm.model.platforms,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.model,
                                              "platforms",
                                              $$v
                                            )
                                          },
                                          expression: "model.platforms"
                                        }
                                      }),
                                      _c(
                                        "v-expansion-panels",
                                        { attrs: { accordion: "" } },
                                        [
                                          _c(
                                            "v-expansion-panel",
                                            { key: "showLinkOverrides" },
                                            [
                                              _c("v-expansion-panel-header", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "catalogedit.panel.download-links"
                                                    )
                                                  )
                                                )
                                              ]),
                                              _c(
                                                "v-expansion-panel-content",
                                                _vm._l(
                                                  _vm.model.platforms,
                                                  function(platform) {
                                                    return _c(
                                                      "div",
                                                      {
                                                        key: platform,
                                                        attrs: { dense: "" }
                                                      },
                                                      [
                                                        _c("v-text-field", {
                                                          attrs: {
                                                            label: platform,
                                                            rules: [
                                                              _vm.rules.urlRules
                                                            ],
                                                            dense: ""
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.launchLinks[
                                                                platform
                                                              ],
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.launchLinks,
                                                                platform,
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "launchLinks[platform]"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  }
                                                ),
                                                0
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._l(_vm.model.availableLocales, function(locale) {
                        return _c(
                          "v-tab-item",
                          { key: locale },
                          [
                            _c("v-text-field", {
                              attrs: {
                                label: _vm.$t("catalogedit.label.title"),
                                required: ""
                              },
                              model: {
                                value: _vm.model.locales[locale].title,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.model.locales[locale],
                                    "title",
                                    $$v
                                  )
                                },
                                expression: "model.locales[locale].title"
                              }
                            }),
                            _c("v-text-field", {
                              attrs: {
                                label: _vm.$t("catalogedit.label.promo-text")
                              },
                              model: {
                                value: _vm.model.locales[locale].promoText,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.model.locales[locale],
                                    "promoText",
                                    $$v
                                  )
                                },
                                expression: "model.locales[locale].promoText"
                              }
                            }),
                            _c("v-combobox", {
                              staticClass: "tag-input",
                              attrs: {
                                multiple: "",
                                label: _vm.$t("catalogedit.label.keywords"),
                                "append-icon": "",
                                chips: "",
                                "deletable-chips": ""
                              },
                              model: {
                                value: _vm.model.locales[locale].keywords,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.model.locales[locale],
                                    "keywords",
                                    $$v
                                  )
                                },
                                expression: "model.locales[locale].keywords"
                              }
                            }),
                            _vm._l(_vm.model.topics, function(topic) {
                              return _c(
                                "div",
                                { key: topic.id },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      value: _vm.topicName(locale, topic.id),
                                      label: topic.id
                                    },
                                    on: {
                                      input: function(newValue) {
                                        return _vm.updateTopicName(
                                          newValue,
                                          locale,
                                          topic.id
                                        )
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            }),
                            _vm._l(_vm.model.locales[locale].extras, function(
                              fieldValue,
                              fieldName
                            ) {
                              return _c(
                                "div",
                                { key: fieldName },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      value: fieldValue,
                                      label: fieldName
                                    },
                                    on: {
                                      input: function(newValue) {
                                        return _vm.updateLocaleField(
                                          newValue,
                                          locale,
                                          fieldName
                                        )
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            }),
                            _c(
                              "div",
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: { icon: "", small: "" },
                                    on: { click: _vm.addNewLocaleAttribute }
                                  },
                                  [_c("v-icon", [_vm._v("mdi-plus")])],
                                  1
                                ),
                                _c("v-text-field", {
                                  attrs: {
                                    label: _vm.$t(
                                      "catalogedit.label.new-locale"
                                    )
                                  },
                                  model: {
                                    value: _vm.newLocaleAttribute,
                                    callback: function($$v) {
                                      _vm.newLocaleAttribute = $$v
                                    },
                                    expression: "newLocaleAttribute"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "div",
                              [
                                _c("v-col", [
                                  _c("h3", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("catalogedit.label.promo-list")
                                      )
                                    )
                                  ])
                                ])
                              ],
                              1
                            ),
                            _vm._l(
                              _vm.model.locales[locale].promoList,
                              function(line, index) {
                                return _c(
                                  "div",
                                  { key: index },
                                  [
                                    _c("v-text-field", {
                                      model: {
                                        value:
                                          _vm.model.locales[locale].promoList[
                                            index
                                          ],
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.model.locales[locale].promoList,
                                            index,
                                            $$v
                                          )
                                        },
                                        expression:
                                          "model.locales[locale].promoList[index]"
                                      }
                                    })
                                  ],
                                  1
                                )
                              }
                            ),
                            _c(
                              "div",
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: { icon: "", small: "" },
                                    on: {
                                      click: function($event) {
                                        return _vm.addPromo(locale)
                                      }
                                    }
                                  },
                                  [_c("v-icon", [_vm._v("mdi-plus")])],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "div",
                              [
                                _c("v-text-field", {
                                  attrs: {
                                    label: _vm.$t("catalogedit.label.new-promo")
                                  },
                                  model: {
                                    value: _vm.newPromo,
                                    callback: function($$v) {
                                      _vm.newPromo = $$v
                                    },
                                    expression: "newPromo"
                                  }
                                })
                              ],
                              1
                            ),
                            _c("v-switch", {
                              attrs: {
                                label: _vm.$t("catalogedit.label.captioned")
                              },
                              model: {
                                value: _vm.model.locales[locale].captioned,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.model.locales[locale],
                                    "captioned",
                                    $$v
                                  )
                                },
                                expression: "model.locales[locale].captioned"
                              }
                            })
                          ],
                          2
                        )
                      })
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { disabled: _vm.loading, color: "grey" },
                  on: { click: _vm.importJson }
                },
                [_vm._v(" " + _vm._s(_vm.$t("global.import")) + " ")]
              ),
              _c(
                "v-btn",
                {
                  attrs: { disabled: _vm.loading, color: "grey" },
                  on: { click: _vm.exportJson }
                },
                [_vm._v(" " + _vm._s(_vm.$t("global.export")) + " ")]
              ),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1" },
                  on: { click: _vm.cancel }
                },
                [_vm._v(" " + _vm._s(_vm.$t("global.cancel")) + " ")]
              ),
              _c(
                "v-btn",
                {
                  attrs: { disabled: !_vm.valid, color: "success" },
                  on: { click: _vm.validate }
                },
                [_vm._v(" " + _vm._s(_vm.$t("global.save")) + " ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }